<template>
  <div>
    <tooltip label="Edit" type="default" placement="left">
      <a class="button button-table is-small" @click="edit()" v-if="parseInt($store.state.config.user.level) < 99 || (parseInt($store.state.config.user.level) === 99 && $store.state.config.user.admin)">
        <i class="fa fa-pencil"></i>
      </a>
    </tooltip>
    <tooltip label="Export User to EZConnect" type="default" placement="left">
      <a class="button button-table is-small" :class="{'is-disabled': inProgress}" @click="exportCR()" v-if="parseInt($store.state.config.user.level) < 99 && data.ezconnect_id === null && data.agency_ezconnect_id !== null">
        <i class="fa fa-link"></i>
      </a>
    </tooltip>
    <!-- <template v-if="$store.state.config.user.admin || parseInt($store.state.config.user.level) < 99">
      <template v-if="parseInt(this.data.active) == 1">
        <tooltip label="Disable" type="default" placement="left">
          <a class="button button-table is-small" @click="disable()">
            <i class="fa fa-toggle-off "></i>
          </a>
        </tooltip>
      </template>
      <template v-else>
        <tooltip label="Enable" type="default" placement="left">
          <a class="button button-table is-small" @click="enable()">
            <i class="fa fa-toggle-on "></i>
          </a>
        </tooltip>
      </template>
    </template> -->
  </div>
</template>

<script>
  import Tooltip from 'vue-bulma-tooltip'
  import Message from '../../utils/message'
  import Users from './users'
  export default {
    data () {
      return {
        inProgress: false
      }
    },
    props: {
      data: {
        type: Object,
        required: true
      }
    },
    components: {
      Tooltip
    },
    methods: {
      edit () {
        let propsData = {
          context: this,
          user_id: parseInt(this.data.id),
          title: 'Edit Client',
          callback: 'clientCallback'
        }
        Users.openClient(propsData)
      },
      exportCR () {
        this.inProgress = true
        this.$http.post(this.$store.state.config.apiURL + '/user/' + this.data.id + '/export').then((response) => {
          let propsData = null
          propsData = {
            title: 'Success',
            message: 'User ' + this.data.name + ' has been exported!',
            type: 'success',
            direction: 'down',
            duration: 4500,
            showCloseButton: true
          }
          this.inProgress = false
          Message.openMessage(propsData)
          this.$parent.loadData()
        }, (response) => {
          this.inProgress = false
        })
      },
      enable () {
        if (window.confirm('Are you sure you want to enable the user?')) {
          this.$http.post(this.$store.state.config.apiURL + '/user/' + this.data.id + '/enable').then((response) => {
            let propsData = null
            propsData = {
              title: 'Success',
              message: 'User ' + this.data.name + ' has been enabled!',
              type: 'success',
              direction: 'down',
              duration: 4500,
              showCloseButton: true
            }

            Message.openMessage(propsData)
            this.$parent.loadData()
          }, (response) => {

          })
        }
      },
      disable () {
        if (window.confirm('Are you sure you want to disable the user?')) {
          this.$http.post(this.$store.state.config.apiURL + '/user/' + this.data.id + '/disable').then((response) => {
            let propsData = null
            propsData = {
              title: 'Success',
              message: 'User ' + this.data.name + ' has been disabled!',
              type: 'success',
              direction: 'down',
              duration: 4500,
              showCloseButton: true
            }
            Message.openMessage(propsData)
            this.$parent.loadData()
          }, (response) => {

          })
        }
      },
      clientCallback (result) {
        let propsData = null
        if (result.ok) {
          propsData = {
            title: 'Success',
            message: result.message,
            type: 'success',
            direction: 'down',
            duration: 4500,
            showCloseButton: true
          }
          Message.openMessage(propsData)
          this.$parent.loadData()
        }
      },
      user () {
        if (this.context.$store.state.config.user) {
          return this.context.$store.state.config.user
        } else {
          return null
        }
      }
    }
  }
</script>

<style lang="scss">
  .button-table {
    padding-top: 6px;
  }
</style>



// WEBPACK FOOTER //
// ClientTableButtons.vue?31779a7e